import {BehaviorSubject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {wwData$} from './worker-data';

export const fiatRate$ = new BehaviorSubject<PriceEntity>({priceEp: 10000, price: '1'});

wwData$.pipe(filter((o) => o.type === 'fiat-rate')).subscribe(({data}) => fiatRate$.next(data.fiatRate));
